import React from "react";

export const SocialInstagram: React.FC<DogsTrust.IconProps> = ({
	height = "40px",
	width = "40px",
	fillPrimary = "#FFC800",
	fillSecondary = "#222",
	invert,
	...props
}) => {
	return (
		<svg
			aria-hidden="true"
			focusable="false"
			width={width}
			height={height}
			viewBox="0 0 40 40"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<g fill="none" fillRule="evenodd">
				<circle
					fill={invert ? fillSecondary : fillPrimary}
					cx={20}
					cy={20}
					r={20}
				/>
				<path
					d="M20.874 30.5c1.838-.003 3.174-.026 4.009-.07.89-.047 1.664-.18 2.32-.399a5.464 5.464 0 002.04-1.289 5.464 5.464 0 001.288-2.039c.219-.656.352-1.43.399-2.32.047-.89.07-2.352.07-4.383v-.735c-.004-1.65-.02-2.859-.047-3.624-.062-.907-.203-1.688-.422-2.344a5.464 5.464 0 00-1.289-2.04 5.464 5.464 0 00-2.039-1.288c-.656-.219-1.43-.352-2.32-.399-.89-.047-2.352-.07-4.383-.07h-.374c-1.838.003-3.174.026-4.009.07-.89.047-1.664.18-2.32.399-.781.281-1.461.71-2.04 1.289a5.464 5.464 0 00-1.288 2.039c-.219.656-.352 1.43-.399 2.32-.047.89-.07 2.352-.07 4.383v.374c.003 1.838.026 3.174.07 4.009.047.89.18 1.664.399 2.32.281.781.71 1.461 1.289 2.04a4.997 4.997 0 002.039 1.241c.656.25 1.43.399 2.32.446.89.047 2.352.07 4.383.07h.374zm.376-1.875h-1.5c-1.25 0-2.219-.016-2.906-.047-1.157-.062-2-.187-2.532-.375-.937-.375-1.609-1.047-2.015-2.015-.188-.532-.313-1.375-.375-2.532a68.389 68.389 0 01-.047-2.906v-1.5c0-1.25.016-2.219.047-2.906.062-1.188.187-2.031.375-2.531.375-.97 1.047-1.641 2.015-2.016.532-.188 1.375-.313 2.532-.375a68.389 68.389 0 012.906-.047h1.867a62.8 62.8 0 012.54.047c1.187.062 2.03.187 2.53.375.97.375 1.641 1.047 2.016 2.016.188.5.313 1.343.375 2.53.031.657.047 1.626.047 2.907v1.867a62.8 62.8 0 01-.047 2.54c-.062 1.156-.187 2-.375 2.53-.375.938-1.047 1.61-2.016 2.016-.5.188-1.343.313-2.53.375-.657.031-1.626.047-2.907.047zm4.875-12.984c.344 0 .633-.125.867-.375a1.46 1.46 0 00.399-.891c0-.344-.125-.64-.375-.89a1.217 1.217 0 00-.891-.376c-.344 0-.64.125-.89.375s-.376.547-.376.891.125.64.375.89.547.376.891.376zM20.5 25.39c.969 0 1.867-.243 2.695-.727a5.406 5.406 0 001.969-1.969A5.245 5.245 0 0025.891 20c0-.969-.243-1.867-.727-2.695a5.406 5.406 0 00-1.969-1.969 5.245 5.245 0 00-2.695-.727c-.969 0-1.867.243-2.695.727a5.406 5.406 0 00-1.97 1.969A5.245 5.245 0 0015.11 20c0 .969.243 1.867.727 2.695a5.406 5.406 0 001.969 1.97 5.245 5.245 0 002.695.726zm0-1.875a3.386 3.386 0 01-2.484-1.032A3.386 3.386 0 0116.984 20c0-.969.344-1.797 1.032-2.484a3.386 3.386 0 012.484-1.032c.969 0 1.797.344 2.484 1.032A3.386 3.386 0 0124.016 20c0 .969-.344 1.797-1.032 2.484a3.386 3.386 0 01-2.484 1.032z"
					fill={invert ? fillPrimary : fillSecondary}
					fillRule="nonzero"
				/>
			</g>
		</svg>
	);
};

export default SocialInstagram;
